var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "chart") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 2.1818,
    stroke: "#000",
    d: "M7.273 16c0 1.607-1.302 2.909-2.909 2.909s-2.909-1.302-2.909-2.909c0-1.607 1.302-2.909 2.909-2.909s2.909 1.302 2.909 2.909z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 2.1818,
    stroke: "#000",
    d: "M18.909 16c0 1.607-1.302 2.909-2.909 2.909s-2.909-1.302-2.909-2.909c0-1.607 1.302-2.909 2.909-2.909s2.909 1.302 2.909 2.909z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 2.1818,
    stroke: "#000",
    d: "M30.545 16c0 1.607-1.302 2.909-2.909 2.909s-2.909-1.302-2.909-2.909c0-1.607 1.302-2.909 2.909-2.909s2.909 1.302 2.909 2.909z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 2.1818,
    stroke: "#000",
    d: "M7.273 4.364c0 1.607-1.302 2.909-2.909 2.909s-2.909-1.302-2.909-2.909c0-1.607 1.302-2.909 2.909-2.909s2.909 1.302 2.909 2.909z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 2.1818,
    stroke: "#000",
    d: "M18.909 4.364c0 1.607-1.302 2.909-2.909 2.909s-2.909-1.302-2.909-2.909 1.302-2.909 2.909-2.909c1.607 0 2.909 1.302 2.909 2.909z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 2.1818,
    stroke: "#000",
    d: "M30.545 4.364c0 1.607-1.302 2.909-2.909 2.909s-2.909-1.302-2.909-2.909c0-1.607 1.302-2.909 2.909-2.909s2.909 1.302 2.909 2.909z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 2.1818,
    stroke: "#000",
    d: "M7.273 27.636c0 1.607-1.302 2.909-2.909 2.909s-2.909-1.302-2.909-2.909c0-1.607 1.302-2.909 2.909-2.909s2.909 1.302 2.909 2.909z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 2.1818,
    stroke: "#000",
    d: "M18.909 27.636c0 1.607-1.302 2.909-2.909 2.909s-2.909-1.302-2.909-2.909 1.302-2.909 2.909-2.909c1.607 0 2.909 1.302 2.909 2.909z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 2.1818,
    stroke: "#000",
    d: "M30.545 27.636c0 1.607-1.302 2.909-2.909 2.909s-2.909-1.302-2.909-2.909c0-1.607 1.302-2.909 2.909-2.909s2.909 1.302 2.909 2.909z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.fea10e40b882261e7395e19d37c57ddc.svg";
export { ForwardRef as ReactComponent };